import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';

import http from '../services/httpService';

import { Textbox } from 'react-inputs-validation';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';

class PasswordResetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      confirmPassword: '',
      errors: {},
      loading: false,
      validate: false,
      hasPasswordError: true,
      hasConfirmPasswordError: true,
      hasEmailError: true,
    };
    this.validateForm = this.validateForm.bind(this);
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  async validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasPasswordError,
      hasConfirmPasswordError,
      hasEmailError,
    } = this.state;
    if (!hasPasswordError && !hasConfirmPasswordError && !hasEmailError) {
      this.setState({ loading: true });

      // Call the server
      try {
        const { email, password } = this.state;
        const result = await http.post('users/reset-password', {
          email,
          password,
          token: this.props.match.params.id,
        });
        this.setState({ loading: false });
        if (result.data.status === 200) {
          confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
              return (
                <div className="row">
                  <div
                    className="custom-ui"
                    style={{ backgroundColor: 'green' }}
                  >
                    <div className="icon-box">
                      <i className="fas fa-check-circle fa-4x" />
                    </div>
                    <h1>{result.data.message}</h1>
                    <p>
                      Account password for{' '}
                      <span style={{ color: '#010A4D', fontWeight: 'bold' }}>
                        {email}{' '}
                      </span>{' '}
                      has been successfully updated. You can go back to using
                      Jeroid App.
                    </p>

                    <button
                      onClick={() => {
                        document.location.href = '/password-reset';
                        onClose();
                      }}
                    >
                      OK
                    </button>
                  </div>
                </div>
              );
            },
          });
        }
      } catch (ex) {
        if (ex.response && ex.response.status === 400) {
          this.setState({ loading: false });
          toast(ex.response.data.message);
        }
      }
    }
  }

  render() {
    const { validate, email, password, confirmPassword } = this.state;
    const rowStyle = {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      padding: '2%',
      fontSize: '14px',
    };
    const rowWrapperStyle = {
      display: 'table',
      width: '100%',
    };
    return (
      <div className="row">
        <div className="col-md-4 offset-md-4">
          <div
            className="card card-login mx-auto mt-5"
            style={{ border: 0, borderRadius: 0 }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: 'white',
                borderBottom: 0,
                marginTop: 10 + '%',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              Reset Password
            </div>
            <div className="card-body">
              <div className="text-center mb-4">
                <h4>Did You Request Password?</h4>
                <p>
                  If so, you are about to reset your account password by filling
                  the form below
                </p>
              </div>
              <form onSubmit={this.validateForm}>
                <div style={rowWrapperStyle}>
                  <div>
                    <div style={rowStyle}>
                      <div style={{ flex: '6 6 0px' }}>
                        <label
                          style={{
                            display: 'block',
                            color: 'black',
                            fontWeight: 'bold',
                            fontSize: 12 + 'px',
                          }}
                          htmlFor="email"
                        >
                          Account Email
                        </label>
                        <Textbox
                          attributesWrapper={{}}
                          attributesInput={{
                            id: 'email',
                            name: 'email',
                            type: 'text',
                            autoFocus: true,
                          }}
                          value={email} // Optional.[String].Default: "".
                          disabled={false} // Optional.[Bool].Default: false.
                          validate={validate} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                          validationCallback={(res) =>
                            this.setState({
                              hasEmailError: res,
                              validate: false,
                            })
                          } // Optional.[Func].Default: none. Return the validation result.
                          classNameInput="" // Optional.[String].Default: "".
                          classNameWrapper="" // Optional.[String].Default: "".
                          classNameContainer="" // Optional.[String].Default: "".
                          customStyleInput={{}} // Optional.[Object].Default: {}.
                          customStyleWrapper={{}} // Optional.[Object].Default: {}.
                          customStyleContainer={{}} // Optional.[Object].Default: {}.
                          onChange={(email, e) => {
                            this.setState({ email });
                          }} // Required.[Func].Default: () => {}. Will return the value.
                          onBlur={(e) => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationOption={{
                            name: 'Email Address', // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            type: 'string', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            msgOnError: 'Enter a valid email address',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={rowWrapperStyle}>
                  <div>
                    <div style={rowStyle}>
                      <div style={{ flex: '6 6 0px' }}>
                        <label
                          style={{
                            display: 'block',
                            color: 'black',
                            fontWeight: 'bold',
                            fontSize: 12 + 'px',
                          }}
                          htmlFor="password"
                        >
                          Set New Password
                        </label>
                        <Textbox
                          attributesWrapper={{}}
                          attributesInput={{
                            id: 'password',
                            name: 'password',
                            type: 'password',
                          }}
                          value={password} // Optional.[String].Default: "".
                          disabled={false} // Optional.[Bool].Default: false.
                          validate={validate} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                          validationCallback={(res) =>
                            this.setState({
                              hasPasswordError: res,
                              validate: false,
                            })
                          } // Optional.[Func].Default: none. Return the validation result.
                          classNameInput="" // Optional.[String].Default: "".
                          classNameWrapper="" // Optional.[String].Default: "".
                          classNameContainer="" // Optional.[String].Default: "".
                          customStyleInput={{}} // Optional.[Object].Default: {}.
                          customStyleWrapper={{}} // Optional.[Object].Default: {}.
                          customStyleContainer={{}} // Optional.[Object].Default: {}.
                          onChange={(password, e) => {
                            this.setState({ password });
                          }} // Required.[Func].Default: () => {}. Will return the value.
                          onBlur={(e) => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          // onFocus={(e) => {console.log(e);}} // Optional.[Func].Default: none.
                          // onClick={(e) => {console.log(e);}} // Optional.[Func].Default: none.
                          validationOption={{
                            name: 'Password', // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            type: 'string', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                            //reg: /^(?=.*([A-Z]){1,})(?=.*[!@#$&*]{1,})(?=.*[0-9]{1,})(?=.*[a-z]{1,}).{8,100}$/,
                            //msgOnError:
                            //  'Minimum of 8 Xters(1 Uppercase, 1 Lowercase, 1 special char)',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={rowWrapperStyle}>
                  <div>
                    <div style={rowStyle}>
                      <div style={{ flex: '6 6 0px' }}>
                        <label
                          style={{
                            display: 'block',
                            color: 'black',
                            fontWeight: 'bold',
                            fontSize: 12 + 'px',
                          }}
                          htmlFor="confirmPassword"
                        >
                          Confirm Password
                        </label>
                        <Textbox
                          attributesWrapper={{}}
                          attributesInput={{
                            id: 'confirmPassword',
                            name: 'ConfirmPassword',
                            type: 'password',
                          }}
                          value={confirmPassword} // Optional.[String].Default: "".
                          disabled={false} // Optional.[Bool].Default: false.
                          validate={validate} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                          validationCallback={(res) =>
                            this.setState({
                              hasConfirmPasswordError: res,
                              validate: false,
                            })
                          } // Optional.[Func].Default: none. Return the validation result.
                          classNameInput="" // Optional.[String].Default: "".
                          classNameWrapper="" // Optional.[String].Default: "".
                          classNameContainer="" // Optional.[String].Default: "".
                          customStyleInput={{}} // Optional.[Object].Default: {}.
                          customStyleWrapper={{}} // Optional.[Object].Default: {}.
                          customStyleContainer={{}} // Optional.[Object].Default: {}.
                          onChange={(confirmPassword, e) => {
                            this.setState({ confirmPassword });
                          }} // Required.[Func].Default: () => {}. Will return the value.
                          onBlur={(e) => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationOption={{
                            name: 'Confirm Password', // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            type: 'string', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                            compare: password,
                            //msgOnError:
                            //  'Ensure Confirm Password box match your set Password', // Optional.[String].Default: "" Show your custom error message no matter what when it has error if it is provied.
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  onClick={this.validateForm}
                  className="btn btn-invest btn-block"
                >
                  Reset Password
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PasswordResetForm;
